import { render } from "./LinksView.vue?vue&type=template&id=5efb951e"
import script from "./LinksView.vue?vue&type=script&lang=js"
export * from "./LinksView.vue?vue&type=script&lang=js"

import "./LinksView.vue?vue&type=style&index=0&id=5efb951e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__